export default __webpack_public_path__ + "static/media/logo-thinksono.f6b6350f.png";